"use client"

import MenuHero from "@/components/menu-hero"
import CategoriesSection from "@/components/categories-section"
import BeveragesSection from "@/components/beverages-section"
import Footer from "@/components/footer"
import OrderStatusModal from "@/components/order-status-modal"
import OrderCompletionModal from "@/components/order-completion-modal"
import ConnectionStatus from "@/components/connection-status"
import NotificationContainer from "@/components/notification-container"
import FloatingNav from "@/components/floating-nav"
import BuffetAd from "@/components/buffet-ad"
import { useApp } from "@/lib/context"

interface MenuTemplateProps {
  isLoading?: boolean
  onLoadingComplete?: () => void
}

export default function ModernMenu({ isLoading = false, onLoadingComplete }: MenuTemplateProps) {
  const { categoriesBebidas } = useApp()

  return (
    <main className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white">
      {/* Modern Theme: Sleek dark with orange accents */}

      <MenuHero />

      <BuffetAd />

      <CategoriesSection variant="modern" />

      {categoriesBebidas.length > 0 && (
        <BeveragesSection />
      )}

      <Footer />

      {/* Modais e overlays partilhados */}
      <OrderStatusModal />
      <OrderCompletionModal />
      <NotificationContainer />
      <ConnectionStatus />
      <FloatingNav />
    </main>
  )
}
